import { useEffect } from 'react'
import { useSearchParams } from 'react-router'

import { EMPTY_OBJECT } from '../constants/common'
import { SUBMENU_DEFAULT_VALUE, SUBMENU_PARAM_KEY } from '../constants/route'
import { getValidSubParam, isLegacySubParam } from '../utils/route'

export function useDefaultParams(config) {
  const { defaultSub = SUBMENU_DEFAULT_VALUE } = config || EMPTY_OBJECT

  const [searchParams, setSearchParams] = useSearchParams()

  const sub = searchParams.get(SUBMENU_PARAM_KEY)

  useEffect(() => {
    if (sub) {
      if (isLegacySubParam(sub)) {
        setSearchParams(
          {
            ...Object.fromEntries(searchParams.entries()),
            [SUBMENU_PARAM_KEY]: getValidSubParam(sub),
          },
          { replace: true }
        )
      }
    } else {
      const params = {
        [SUBMENU_PARAM_KEY]: getValidSubParam(sub) || defaultSub,
      }

      setSearchParams(params, { replace: true })
    }
  }, [sub])
}
